import apiClient from "../api/apiClient";
import { endPoints } from "../config/endpoints";

export const dashboardService = {
    async getStatisticsAsync()
    {
         const response=await apiClient.get(endPoints.dashboard.getStatistics);
         return response.data
    },
    async searchAsync(query, signal)
    {
        const response = await apiClient.get(endPoints.dashboard.search, {
            params: { q: query },
            signal,
        });
        return response.data;
    },
}